import React, { useEffect } from "react";
import ReactHtmlParser from 'react-html-parser';
import "./style.css";



function NewDetail(props) {
  const { content } = props.data;

  var display=null;
  if (content.length>0)
  {
    display=<>
      <div className="header_box ">
            <h5>
              <strong>{content[0]["title"]}</strong>
            </h5>
          </div>
          <div className="row banner_img">
            {content[0]["blog_images"].map((val) => {
              return <div className="img-container"><img src={val.full_path} alt="" className="responsive-img"/></div>;
            })}
          </div>
          <div className="body">
            {ReactHtmlParser(content[0]["body"])}
          </div>
    </>
  }
  else 
  {
    display=<div className="row center">
      <h4>No Post Found</h4>
    </div>
  }

  return (
    <div className="row new_detail">
          {display}
    </div>
  );
}
export default NewDetail;
